module.exports = __webpack_public_path__ + "img/serve_10@2x.a5d5798c.png";